import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    event.preventDefault()
    const url = new URL(this.element.action)
    const params = new URLSearchParams(new FormData(this.element))

    url.search = params.toString()
    url.hash = "hotel-card"
    window.location.href = url.toString()
  }
}
